import * as $ from 'jquery';
import { onClick, onLoad } from "Core/Events";
import "slick-carousel";
import { createSlickChevron } from '../SlickChevron';

export const Product = (() => {

    const Selector = {
        PRODUCT_GALLERY_CONTAINER: '.js_slick_product_top',
        NAVI_CONTAINER: '.js_slick-product-bottom',
        SLIDER_CONTAINER: '.js_common_products_carousel',
        BUNDLES_CONTAINER: '.js_bundles_carousel',
        COLORS_CONTAINER: '.product-variant-attribute-values',
        COLORS_ITEMS: '.product-data-color',
        SHOW_BUTTON_CONTAINER: '.js_colors_show_container',
        SHOW_BUTTON: '.js_colors_show',
        PROMO_ICONS_SLIDER: '.js_promo_product_carousel',
        SMART_PHOTO_ITEM: '.js-smartphoto',
        COLOR_VARIANT: '.product-variant-attribute-value',
        COLOR_VARIANT_SELECTED: '.product-variant-attribute-value.selected',
        TAGGED_SLIDERS_CONTAINER: '.products-tagged-slider',
        TAB_NAVS: '.products-tagged-slider .nav-item',
        TAB_ITEMS: '.tab-item'
    };

    onLoad(slickGalleryCarousel);
    onLoad(initCommonProductsCarousel);
    onLoad(productColorsHideHandler);
    onLoad(slickPromoIconsSlider);
    onLoad(detectActiveColorHandler);
    onLoad(initBundlesCarousel);
    onClick(Selector.SHOW_BUTTON, colorsShowHandler);
    onClick(Selector.COLOR_VARIANT_SELECTED, colorSelectHandler);

    function slickGalleryCarousel() {
        $(Selector.PRODUCT_GALLERY_CONTAINER).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: Selector.NAVI_CONTAINER,
            prevArrow: createSlickChevron('prev'),
            nextArrow: createSlickChevron('next'),
            infinite: false,
            rows: 0,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        dots: true,
                        prevArrow: createSlickChevron('prev'),
                        nextArrow: createSlickChevron('next'),

                    }
                }
            ]
        });

        $(Selector.NAVI_CONTAINER).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: Selector.PRODUCT_GALLERY_CONTAINER,
            rows: 0,
            variableWidth: false,
            focusOnSelect: true,
            prevArrow: createSlickChevron('prev'),
            nextArrow: createSlickChevron('next'),
            infinite: false,
            responsive: [
                {
                    breakpoint: 1599,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        rows: 0,
                    }
                }
            ]
        });

        //centering slick track for slides when slides is not too much to fill the track. This is becouse specific styling of slide accoding to scratch.
        if($(Selector.NAVI_CONTAINER).find('.slick-slide').length <= 3) {
            $(Selector.NAVI_CONTAINER).find('.slick-track').addClass('d-flex justify-content-center w-auto transform-none');
        }
    }

    function  initCommonProductsCarousel() {
        taggedSlidersInit(); //necessary to correct initialisation first slider inside tab
        if($(Selector.SLIDER_CONTAINER).length) {
            $(Selector.SLIDER_CONTAINER).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipe: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev'),
                nextArrow: createSlickChevron('next'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false
                        }
                    },
                ]
            })
                .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    //BO-1953 transferred and improved loading images
                    $(this)
                        .find('.product-tile-card--image img')
                        .slice(nextSlide, nextSlide + slick.options.slidesToShow)
                        .each(function (index, currentImg) {
                            if ($(currentImg).has('.js_img_not_loaded')) {
                                $(currentImg)
                                    .attr('src', $(currentImg).data('src'))
                                    .removeClass('js_img_not_loaded');
                            }
                        });
                });

            $('.js_tab_product_slider').slick('setPosition');
            $(Selector.SLIDER_CONTAINER).css('visibility', 'visible');
        }
    }

    function  initBundlesCarousel() {
        if($(Selector.BUNDLES_CONTAINER).length) {
            $(Selector.BUNDLES_CONTAINER).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipe: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 0,
                prevArrow: createSlickChevron('prev'),
                nextArrow: createSlickChevron('next'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false
                        }
                    },
                ]
            })
            $(Selector.BUNDLES_CONTAINER).css('visibility', 'visible');
        }
    }

    function taggedSlidersInit() {
        if($(Selector.TAGGED_SLIDERS_CONTAINER).length > 0) { 
            $(Selector.TAGGED_SLIDERS_CONTAINER).find('.tab-item:first').show(); //show first slider
            $(Selector.TAB_NAVS).first().children(':first').addClass('active'); //active class first nav tab 
        }
    }

    function countElements(container) {
        return $(container).children().length;
    }

    function productColorsHideHandler() {

        $(Selector.COLORS_CONTAINER).each( function(index, element) {
            productColorsHide(element);
        })


    }

    function productColorsHide(element) {
        const color_container = $(element);
        const colors_length = countElements(color_container);

        let elements:number = setMaximumElementsCount(color_container);

        if(colors_length > elements) {
            $(element).parent().find(Selector.SHOW_BUTTON_CONTAINER).removeClass('d-none').addClass('d-flex');

            $(color_container).children().each( function(index, el) {
                if (index >= elements) {
                    $(el).hide();
                }
            })
        }
    }

    function setMaximumElementsCount(container) {

        const container_width = $(container).width();
        const item_width = $(container).children().first().outerWidth(true);

        return Math.floor(container_width/item_width);
    }

    function colorsShowHandler() {
        const color_container = $(this).closest('.product-variant-attribute-container').find(Selector.COLORS_CONTAINER);
        const thisButton = $(this)

        if($(this).hasClass('showing')) {
            productColorsHide(color_container);
            $(this).removeClass('showing').html('Rozwiń więcej kolorów<span>&#8595;</span>');
        } else {
            productColorsShow(color_container, thisButton)
        }
    }

    function productColorsShow(container, showButton) {
        const elements = $(container).children().length;
        $(container).children().each( function(index, el) {
            if (index < elements) {
                $(el).show();
            }
        })
        $(showButton).addClass('showing').html('Zwiń więcej kolorów<span>&#8593;</span>');
    }

    function  slickPromoIconsSlider() {
        if($(Selector.PROMO_ICONS_SLIDER).length) {
            $(Selector.PROMO_ICONS_SLIDER).slick({
                infinite: false,
                // arrows: true,
                dots: true,
                fade: false,
                autoplay: false,
                adaptiveHeight: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev', 'poprzednie cechy'),
                nextArrow: createSlickChevron('next', 'następne cechy'),
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                        dots: true,
                        arrows: true,
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                        dots: true,
                        arrows: true,
                    },
                    {
                        breakpoint: 621,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                        dots: true,
                        arrows: true,
                    },
                    {
                        breakpoint: 479,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                        dots: true,
                        arrows: true
                    },
                ]
            });
        }
    }

    function colorSelectHandler(event: JQuery.Event) { //function to handling colors palette on product card
        event.preventDefault(); //prevent open link on element
        $(this).removeClass('selected').addClass('unavailable'); //
        $(this).parent().children().each( function(index, element) {
            $(element).removeClass('unavailable')
        })
    }

    function detectActiveColorHandler() { //detect active color/element in colors container and show all if active element is hidden ()
        //find packs of colors
        let color_container: JQuery<HTMLElement> = $('.product-variant-attribute-container').find(Selector.COLORS_CONTAINER);
        // loop on colors packs
        $(color_container).find(Selector.COLOR_VARIANT).each( function(index, element) {
            //detect active element inside
            const activeEl = detectActiveElement(element);
            if($(activeEl).is(":hidden")) {
                //current container width active hidden element
                const currentColorContainer = $(element).closest('.product-variant-attribute-container').find(Selector.COLORS_CONTAINER);
                //current button to show/hide
                const curentShowButton:JQuery<HTMLElement> = $(element).closest('.product-variant-attribute-container').find(Selector.SHOW_BUTTON);
                productColorsShow(currentColorContainer, curentShowButton);
            }
        })
    };

    function detectActiveElement(color) {
        if($(color).hasClass('selected')) {
            return $(color);
        }
    }



    return true;
})();
import * as $ from 'jquery';
import { onClick, onLoad } from "Core/Events";
import "slick-carousel";
import { createSlickChevron } from '../SlickChevron';

export const Product = (() => {

    const Selector = {
        PRODUCT_GALLERY_CONTAINER: '.js_slick_product_top',
        NAVI_CONTAINER: '.js_slick-product-bottom',
        SLIDER_CONTAINER: '.js_common_products_carousel',
        BUNDLES_CONTAINER: '.js_bundles_carousel',
        COLORS_CONTAINER: '.product-variant-attribute-values',
        COLORS_ITEMS: '.product-data-color',
        SHOW_BUTTON_CONTAINER: '.js_colors_show_container',
        SHOW_BUTTON: '.js_colors_show',
        PROMO_ICONS_SLIDER: '.js_promo_product_carousel',
        SMART_PHOTO_ITEM: '.js-smartphoto',
        COLOR_VARIANT: '.product-variant-attribute-value',
        COLOR_VARIANT_SELECTED: '.product-variant-attribute-value.selected',
        TAGGED_SLIDERS_CONTAINER: '.products-tagged-slider',
        TAB_NAVS: '.products-tagged-slider .nav-item',
        TAB_ITEMS: '.tab-item'
    };

    onLoad(slickGalleryCarousel);
    onLoad(initCommonProductsCarousel);
    onLoad(productColorsHideHandler);
    onLoad(slickPromoIconsSlider);
    onLoad(detectActiveColorHandler);
    onLoad(initBundlesCarousel);
    onClick(Selector.SHOW_BUTTON, colorsShowHandler);
    onClick(Selector.COLOR_VARIANT_SELECTED, colorSelectHandler);

    function slickGalleryCarousel() {
        $(Selector.PRODUCT_GALLERY_CONTAINER).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: Selector.NAVI_CONTAINER,
            prevArrow: createSlickChevron('prev'),
            nextArrow: createSlickChevron('next'),
            infinite: false,
            rows: 0,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        dots: true,
                        prevArrow: createSlickChevron('prev'),
                        nextArrow: createSlickChevron('next'),

                    }
                }
            ]
        });

        $(Selector.NAVI_CONTAINER).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: Selector.PRODUCT_GALLERY_CONTAINER,
            rows: 0,
            variableWidth: false,
            focusOnSelect: true,
            prevArrow: createSlickChevron('prev'),
            nextArrow: createSlickChevron('next'),
            infinite: false,
            responsive: [
                {
                    breakpoint: 1599,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        rows: 0,
                    }
                }
            ]
        });

        //centering slick track for slides when slides is not too much to fill the track. This is becouse specific styling of slide accoding to scratch.
        if($(Selector.NAVI_CONTAINER).find('.slick-slide').length <= 3) {
            $(Selector.NAVI_CONTAINER).find('.slick-track').addClass('d-flex justify-content-center w-auto transform-none');
        }
    }

    function  initCommonProductsCarousel() {
        taggedSlidersInit(); //necessary to correct initialisation first slider inside tab
        if($(Selector.SLIDER_CONTAINER).length) {
            $(Selector.SLIDER_CONTAINER).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipe: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev'),
                nextArrow: createSlickChevron('next'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false
                        }
                    },
                ]
            })
                .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    //BO-1953 transferred and improved loading images
                    $(this)
                        .find('.product-tile-card--image img')
                        .slice(nextSlide, nextSlide + slick.options.slidesToShow)
                        .each(function (index, currentImg) {
                            if ($(currentImg).has('.js_img_not_loaded')) {
                                $(currentImg)
                                    .attr('src', $(currentImg).data('src'))
                                    .removeClass('js_img_not_loaded');
                            }
                        });
                });

            $('.js_tab_product_slider').slick('setPosition');
            $(Selector.SLIDER_CONTAINER).css('visibility', 'visible');
        }
    }

    function  initBundlesCarousel() {
        if($(Selector.BUNDLES_CONTAINER).length) {
            $(Selector.BUNDLES_CONTAINER).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipe: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                rows: 0,
                prevArrow: createSlickChevron('prev'),
                nextArrow: createSlickChevron('next'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false
                        }
                    },
                ]
            })
            $(Selector.BUNDLES_CONTAINER).css('visibility', 'visible');
        }
    }

    function taggedSlidersInit() {
        if($(Selector.TAGGED_SLIDERS_CONTAINER).length > 0) { 
            $(Selector.TAGGED_SLIDERS_CONTAINER).find('.tab-item:first').show(); //show first slider
            $(Selector.TAB_NAVS).first().children(':first').addClass('active'); //active class first nav tab 
        }
    }

    function countElements(container) {
        return $(container).children().length;
    }

    function productColorsHideHandler() {

        $(Selector.COLORS_CONTAINER).each( function(index, element) {
            productColorsHide(element);
        })


    }

    function productColorsHide(element) {
        const color_container = $(element);
        const colors_length = countElements(color_container);

        let elements:number = setMaximumElementsCount(color_container);

        if(colors_length > elements) {
            $(element).parent().find(Selector.SHOW_BUTTON_CONTAINER).removeClass('d-none').addClass('d-flex');

            $(color_container).children().each( function(index, el) {
                if (index >= elements) {
                    $(el).hide();
                }
            })
        }
    }

    function setMaximumElementsCount(container) {

        const container_width = $(container).width();
        const item_width = $(container).children().first().outerWidth(true);

        return Math.floor(container_width/item_width);
    }

    function colorsShowHandler() {
        const color_container = $(this).closest('.product-variant-attribute-container').find(Selector.COLORS_CONTAINER);
        const thisButton = $(this)

        if($(this).hasClass('showing')) {
            productColorsHide(color_container);
            $(this).removeClass('showing').html('Rozwiń więcej kolorów<span>&#8595;</span>');
        } else {
            productColorsShow(color_container, thisButton)
        }
    }

    function productColorsShow(container, showButton) {
        const elements = $(container).children().length;
        $(container).children().each( function(index, el) {
            if (index < elements) {
                $(el).show();
            }
        })
        $(showButton).addClass('showing').html('Zwiń więcej kolorów<span>&#8593;</span>');
    }

    function  slickPromoIconsSlider() {
        if($(Selector.PROMO_ICONS_SLIDER).length) {
            $(Selector.PROMO_ICONS_SLIDER).slick({
                infinite: false,
                // arrows: true,
                dots: true,
                fade: false,
                autoplay: false,
                adaptiveHeight: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                rows: 0,
                prevArrow: createSlickChevron('prev', 'poprzednie cechy'),
                nextArrow: createSlickChevron('next', 'następne cechy'),
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                        dots: true,
                        arrows: true,
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                        dots: true,
                        arrows: true,
                    },
                    {
                        breakpoint: 621,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                        dots: true,
                        arrows: true,
                    },
                    {
                        breakpoint: 479,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                        dots: true,
                        arrows: true
                    },
                ]
            });
        }
    }

    function colorSelectHandler(event: JQuery.Event) { //function to handling colors palette on product card
        event.preventDefault(); //prevent open link on element
        $(this).removeClass('selected').addClass('unavailable'); //
        $(this).parent().children().each( function(index, element) {
            $(element).removeClass('unavailable')
        })
    }

    function detectActiveColorHandler() { //detect active color/element in colors container and show all if active element is hidden ()
        //find packs of colors
        let color_container: JQuery<HTMLElement> = $('.product-variant-attribute-container').find(Selector.COLORS_CONTAINER);
        // loop on colors packs
        $(color_container).find(Selector.COLOR_VARIANT).each( function(index, element) {
            //detect active element inside
            const activeEl = detectActiveElement(element);
            if($(activeEl).is(":hidden")) {
                //current container width active hidden element
                const currentColorContainer = $(element).closest('.product-variant-attribute-container').find(Selector.COLORS_CONTAINER);
                //current button to show/hide
                const curentShowButton:JQuery<HTMLElement> = $(element).closest('.product-variant-attribute-container').find(Selector.SHOW_BUTTON);
                productColorsShow(currentColorContainer, curentShowButton);
            }
        })
    };

    function detectActiveElement(color) {
        if($(color).hasClass('selected')) {
            return $(color);
        }
    }



    return true;
})();
